/** The env-var names `buildServerConfig` reads: the NEXT_PUBLIC_ app-config names it maps each `EnvironmentConfig` key to (the same names appear in each app's wrangler.jsonc), and Next's build-phase marker it skips the live integrity check on. */

/** Env-var NAMES exposed to browser bundles, grouped 2026-08-09 (QUAL-CONST-GROUP-001: HTTP_STATUS pattern) from 23 flat per-var exports. Every member is the RAW env-var name, never its value. */
export const ENV_NEXT_PUBLIC = {
	/** Storage Gateway API base URL. */
	STORAGE_GATEWAY_API: 'NEXT_PUBLIC_STORAGE_GATEWAY_API',
	/** Conversations API base URL. */
	CONVERSATIONS_API: 'NEXT_PUBLIC_CONVERSATIONS_API',
	PROPERTY_LIST_API: 'NEXT_PUBLIC_PROPERTY_LIST_API',
	/** Explore Durable Object endpoint URL. */
	EXPLORE_DURABLE_OBJECT: 'NEXT_PUBLIC_EXPLORE_DURABLE_OBJECT',
	/** handle-files UI API URL. */
	HANDLE_FILES_API: 'NEXT_PUBLIC_HANDLE_FILES_API',
	CHATROOM_WS: 'NEXT_PUBLIC_CHATROOM_WS',
	/** Explore websocket URL. */
	EXPLORE_WS: 'NEXT_PUBLIC_EXPLORE_WS',
	/** Stripe payment-intent API URL. */
	STRIPE_PAYMENT_INTENT: 'NEXT_PUBLIC_STRIPE_PAYMENT_INTENT',
	/** Application environment selector (dev/prod). */
	APP_ENV: 'NEXT_PUBLIC_APP_ENV',
	/** Database name (dev/prod). */
	DATABASE_NAME: 'NEXT_PUBLIC_DATABASE_NAME',
	/** Stripe publishable key. */
	STRIPE_PUBLIC_KEY: 'NEXT_PUBLIC_STRIPE_PUBLIC_KEY',
	EXPLORE_HTTP: 'NEXT_PUBLIC_EXPLORE_HTTP',
	/** Stripe merchant identifier. */
	MERCHANT_IDENTIFIER: 'NEXT_PUBLIC_MERCHANT_IDENTIFIER',
	/** Canonical app base URL. */
	APP_URL: 'NEXT_PUBLIC_APP_URL',
	ADMIN_APP_URL: 'NEXT_PUBLIC_ADMIN_APP_URL',
	/** Firebase API key. */
	FIREBASE_API_KEY: 'NEXT_PUBLIC_FIREBASE_API_KEY',
	/** Firebase auth-domain. */
	FIREBASE_AUTH_DOMAIN: 'NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN',
	FIREBASE_PROJECT_ID: 'NEXT_PUBLIC_FIREBASE_PROJECT_ID',
	/** Firebase storage bucket. */
	FIREBASE_STORAGE_BUCKET: 'NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET',
	/** Firebase messaging-sender ID. */
	FIREBASE_MESSAGING_SENDER_ID: 'NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID',
	FIREBASE_APP_ID: 'NEXT_PUBLIC_FIREBASE_APP_ID',
	/** Firebase measurement ID. */
	FIREBASE_MEASUREMENT_ID: 'NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID',
	/** INTENTIONALLY public (browser-exposed) per CLAUDE.md "Intentional public tokens" -- do not flag or remove. */
	STATIC_API_TOKEN: 'NEXT_PUBLIC_STATIC_API_TOKEN',
} as const;

// ENV PREFIXES

/** The prefix marking an env var as bundled into browser code (`NEXT_PUBLIC_*`) -- never a secret, by construction.
 *  Every member of {@link ENV_NEXT_PUBLIC} carries it. */
export const BROWSER_EXPOSED_ENV_PREFIX = 'NEXT_PUBLIC_';

// NEXT BUILD PHASE

/** Next's own build-phase marker: `next build` sets `process.env[ENV_KEY]` to `PRODUCTION_BUILD` just before it spawns
 *  the static-generation workers that prerender pages, and nothing sets it on a deployed Worker. `buildServerConfig`
 *  reads it to tell a prerender, where no runtime var is bound BY DESIGN, from a live production render, where an empty
 *  critical var is a broken deploy. The spellings are Next's (`next/constants` PHASE_PRODUCTION_BUILD); they are restated
 *  here because `components/lib/environment.ts` also ships in the Vite SPAs, which must not import `next`. */
export const NEXT_BUILD_PHASE = {
	ENV_KEY: 'NEXT_PHASE',
	PRODUCTION_BUILD: 'phase-production-build',
} as const;
